import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../store/actions/index";
import styles from "./Components.module.scss";
import Axios from "axios";
import { Button, Grid } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ScaleLoader from "react-spinners/ScaleLoader";
import urlLinks from "../../../UrlLinks";
import MultipleSelectFilter from "../../../Utils/FilterComponents/MultipleSelectFilter";
import SearchSelectFilter from "../../../Utils/FilterComponents/SearchSelectFilter";
import AutoSelectFilter from "../../../Utils/FilterComponents/AutoSelectFilter";

const FilterDrawer = (props) => {
  const {
    handleClose,
    resetFilters,
    applyFilters,
    filters,
    setFilters,
    cityId,
    setCityId,
    tcsCenterName,
    setTcsCenterName,
    qualification,
    setQualification,
    role,
    setRole,
    cityList,
    tcsCenterList,
    qualificationsList,
    roleList,
  } = props;
  const { users, tcsJobsDb } = useSelector((state) => state);
  const { modalLoader } = users;
  const {
    multipleCity,
    multipleCenterName,
    multipleQualification,
    multipleRole,
  } = tcsJobsDb;

  const dispatch = useDispatch();
  const { setTcsMultipleSelect } = bindActionCreators(actionCreators, dispatch);

  const activityStatusList = [
    {
      id: 33,
      name: "Blacklist",
    },
    {
      id: 35,
      name: "Backed Out",
    },
  ];

  const handleCancelFilters = () => {
    setCityId(multipleCity);
    setTcsCenterName(multipleCenterName);
    setQualification(multipleQualification);
    setRole(multipleRole);
    handleClose();
  };

  const handleApplyFilters = () => {
    setTcsMultipleSelect(cityId, tcsCenterName, qualification, role);
    applyFilters();
    handleClose();
  };

  const loaderBar = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  const output = modalLoader ? (
    <Grid container style={{ width: "520px", marginTop: "20px" }}>
      {loaderBar}
    </Grid>
  ) : (
    <Grid
      container
      style={{ width: "520px", marginTop: "20px" }}
      className={`${styles.filterContainerDrawer}`}
    >
      <Grid container className={`${styles.FilterHeadingContainer}`}>
        <div>
          <Button
            onClick={handleCancelFilters}
            className={styles.filterCloseArrow}
          >
            <ArrowForwardIcon />
          </Button>
          <span className={styles.filterHeading}>Filters</span>
        </div>
        <div>
          <Button onClick={resetFilters} className={styles.resetFiltersButton}>
            Reset
          </Button>
        </div>
      </Grid>
      <div className={styles.filterHeadingDivider}></div>
      <Grid container className={styles.filtersContainer}>
        <Grid item xs={12} className={`${styles.singleFilterContainer}`}>
          <span className={styles.filterTitle}>City</span>
          <SearchSelectFilter
            filters={filters}
            setFilters={setFilters}
            id="city"
            sourceId={cityId}
            setSourceId={setCityId}
            module="tcsCityListing"
            multiple={true}
            placeholder="Search and select"
            disabled={false}
            arrayList={cityList ? cityList : ""}
          />
        </Grid>
        <Grid item xs={12} className={`${styles.singleFilterContainer}`}>
          <span className={styles.filterTitle}>TCS Center Name</span>
          <SearchSelectFilter
            filters={filters}
            setFilters={setFilters}
            id="tcsCenterName"
            sourceId={tcsCenterName}
            setSourceId={setTcsCenterName}
            module="tcsCenterListing"
            multiple={true}
            placeholder="Search and select"
            disabled={false}
            arrayList={tcsCenterList ? tcsCenterList : ""}
          />
        </Grid>
        <Grid item xs={12} className={`${styles.singleFilterContainer}`}>
          <span className={styles.filterTitle}>Qualification</span>
          <MultipleSelectFilter
            filters={filters}
            setFilters={setFilters}
            id="qualification"
            options={qualificationsList ? qualificationsList : ""}
            multipleFlag={true}
            sourceId={qualification}
            setSourceId={setQualification}
          />
        </Grid>
        <Grid item xs={12} className={`${styles.singleFilterContainer}`}>
          <span className={styles.filterTitle}>Role</span>
          <MultipleSelectFilter
            filters={filters}
            setFilters={setFilters}
            id="role"
            options={roleList ? roleList : ""}
            multipleFlag={true}
            sourceId={role}
            setSourceId={setRole}
          />
        </Grid>
        <Grid item xs={12} className={`${styles.singleFilterContainer}`}>
          <span className={styles.filterTitle}>Activity Status</span>
          <AutoSelectFilter
            filters={filters}
            setFilters={setFilters}
            multipleFlag={false}
            id="activityStatus"
            options={activityStatusList}
            uniqueKey="tcsActivityStatus"
            disabled={
              filters.statusId && filters.statusId !== "-1" ? true : false
            }
          />
        </Grid>
      </Grid>
      <Grid container className={styles.filterButtonDividerContainer}>
        <div className={styles.filterHeadingDivider}></div>
        <Grid container style={{ marginTop: "30px" }} className="padding0">
          <div
            style={{
              paddingRight: "16px",
              paddingLeft: "300px",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleCancelFilters}
              size="medium"
              style={{ color: "#1C4980", borderColor: "#1C4980" }}
            >
              Cancel
            </Button>
          </div>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={handleApplyFilters}
            style={{ backgroundColor: "#1C4980" }}
          >
            Apply
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );

  return output;
};

export default FilterDrawer;
